export default "__VITE_ASSET__CZFrRJvV__"